import { render, staticRenderFns } from "./insertaudio.vue?vue&type=template&id=ceda0634&scoped=true&"
import script from "./insertaudio.vue?vue&type=script&lang=js&"
export * from "./insertaudio.vue?vue&type=script&lang=js&"
import style0 from "./insertaudio.vue?vue&type=style&index=0&id=ceda0634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceda0634",
  null
  
)

export default component.exports